/**
 * "All companies" | "Deleted companies" header for the Companies section (SF-4813).
 * Each tab is its own route, so links and the browser's back button work. The
 * Deleted companies tab is only offered with admin:companies:delete; with
 * nothing else to switch to, no header is shown.
 */
import { usePermissions } from '@refinedev/core';
import { Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';

import { hasPermission } from '../../../utils/permissions';
import { COMPANY_DELETE_PERMISSION } from '../api/companyDeleteClient';

export type CompaniesTabKey = 'all' | 'deleted';

const ROUTES: Record<CompaniesTabKey, string> = {
  all: '/companies',
  deleted: '/companies/deletions',
};

export const CompaniesTabs: React.FC<{ active: CompaniesTabKey }> = ({ active }) => {
  const navigate = useNavigate();
  const { data: permissions } = usePermissions<string[]>();
  if (!hasPermission(permissions ?? [], COMPANY_DELETE_PERMISSION)) return null;
  return (
    <Tabs
      activeKey={active}
      onChange={(key) => navigate(ROUTES[key as CompaniesTabKey])}
      items={[
        { key: 'all', label: 'All companies' },
        { key: 'deleted', label: 'Deleted companies' },
      ]}
      style={{ marginBottom: 0 }}
    />
  );
};
